export function getFullyQualifiedName(source: string, contractName: string) {
  return `${source}:${contractName}`;
}
